
const window = require('window');

const _ = require('lodash');
const ko = require('knockout');


// HACK: export global binding expression dependencies
// Proper feature request issued at https://github.com/knockout/knockout/issues/2024

ko.globals = {
	_: require('lodash'),
};

_.extend(window, ko.globals);

// var origApplyBindings = ko.applyBindings;
// ko.applyBindings = function (viewModel, rootNode) {
// 	if (!(viewModel instanceof ko.bindingContext)) {
// 		viewModel = (new ko.bindingContext(viewModel)).extend(ko.globals);
// 	}
// 	return origApplyBindings(viewModel, rootNode);
// };


const applyBindings = ko.applyBindings.bind(ko);
ko.applyBindings = function (model, element, ...args) {
	if (!element) {
		throw new TypeError("Please provide an element to apply bindings on.");
	}
	return applyBindings(model, element, ...args);
};


ko.isObservableArray = ko.isObservableArray || function (x) {
	return ko.isObservable(x) && 'push' in x;
};

ko.proxy = function (observableSource, ...args) {
	/*
	 * Make a computed that passes all reads and writes to the observable
	 * returned by `observableSource'.
	 */
	if ('function' == typeof observableSource) {
		return ko.pureComputed({
			read: () => observableSource()(),
			write: (x) => observableSource()(x),
		}, ...args);
	}
	throw new TypeError('Invalid argument');
};

ko.map = function (observable, mapOrOptions, owner, options) {
	/*
	 * Map over observable value (returns new observable that proxies and maps
	 * all reads and/or writes)
	 */

	if ('function' == typeof mapOrOptions) {
		// Invoked as ko.map(obs, fn [, that, options])
		options = _.extend({
			read: () => mapOrOptions(observable(), observable),
			write: observable,
			owner: owner,
		}, options);
	} else {
		// Invoked as ko.map({mapRead: fn, mapWrite: fn, ...})
		options = _.extend(mapOrOptions, {
			read: mapOrOptions.mapRead
				? () => mapOrOptions.mapRead(observable(), observable)
				: observable,
			write: mapOrOptions.mapWrite
				? (val) => observable(mapOrOptions.mapWrite(val))
				: observable,
		});
	}

	return ko.pureComputed(options)
		.extend({
			inheritEditable: observable,
		});
};

ko.not = function (subscribable, ...args) {
	/*
	 * Make an inverse computed (all reads and writes are inversed with `!' operator)
	 */

	const not = (x) => !x;

	return ko.map(subscribable, {
		mapRead: not,
		mapWrite: not,
	}, ...args);
};

ko.constant = function (value, ...args) {
	/*
	 * Make an observable with constant value
	 */

	return ko.pureComputed(_.constant(value), ...args);
};

ko.oneOf = function (allowedValues, options, ...args) {
	/*
	 * Observable that can only have one of given values (invalid writes are ignored)
	 */
	options = _.extend({
		equals: null,
	}, options);

	if (ko.isObservable(allowedValues)) {
		// noop
	} else if (_.isArray(allowedValues)) {
		allowedValues = ko.observableArray(allowedValues);
	} else {
		throw new TypeError('Invalid argument');
	}

	const value = ko.observable(allowedValues()[0]);

	const isAllowed = options.equals
		? function (value) {
			let allowed = false;
			_.each(allowedValues(), function (val) {
				if (options.equals(val, value)) {
					allowed = true;
					return false; // break
				}
			});
			return allowed;
		}
		: function (value) {
			return allowedValues().indexOf(value) >= 0;
		};

	const oneOf = ko.computed({
		read: value,
		write: function (x) {
			const allowed = allowedValues();
			if (!allowed || !allowed.length) {
				value(undefined);
			} else if (isAllowed(x)) {
				value(x);
				// HACK?: For some reason this explicit notification is required
				// when it seems that it should not be.
				// This is a workaround for bug #4000741400052322605 where
				// `value` gets it's value changed but `oneOf` does not.
				value.valueHasMutated();
			}
		},
	}, options, ...args);

	allowedValues.subscribe(function (allowed) {
		if (!isAllowed(oneOf())) {
			// current value is no longer allowed, fall back to the first one
			value(allowed[0]);
		}
	});

	oneOf.allowedValues = allowedValues;

	return oneOf;
};

ko.subscribable.fn.mutate = function (mutator) {
	if (!ko.isWritableObservable(this)) {
		throw new TypeError("Can't mutate non-writable observable");
	}
	this(mutator(this()));
};
